import { TweenMax } from 'gsap';

class Video {
  constructor(view = null) {
    this.video = (view ? view.querySelector('.js-video') : document.querySelector('.js-video'));
    this.iframe = this.video.querySelector('.js-iframe');
    this.poster = this.video.querySelector('.js-poster');
    this.playButton = this.video.querySelector('.js-play-button');

    this.state = {
      isPlaying: 0
    };
  }

  play = () => {
    if (this.state.isPlaying) return;

    this.iframe.src += '&autoplay=1';

    this.hide(this.playButton);
    this.hide(this.poster);

    this.state.isPlaying = true;
  }

  hide = (el) => {
    TweenMax.fromTo(
      el,
      0.3,
      { autoAlpha: 1 },
      { autoAlpha: 0 }
    );
  }

  init = () => {
    this.poster.addEventListener('click', this.play, { passive: true });
  }

  destroy = () => {
    this.poster.removeEventListener('click', this.play);
  }
}

export default Video;
